const RequiredStar = () => (
  <span
    style={{
      color: "#e53935",
      marginLeft: "4px",
      fontSize: "14px",
      fontWeight: "600",
    }}
  >
    *
  </span>
);

export default RequiredStar;
